import {CHANGE_LANGUAGE} from "./actions";


export default (previousState = 'all', { type, payload }) => {
    if (type === CHANGE_LANGUAGE) {
        return payload.language;
    }
    return previousState;
}
